import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { VirtualStoreContainerComponent } from 'src/app/components/virtual-store/virtual-store-container/virtual-store-container.component';
import { ProductListComponent } from 'src/app/components/virtual-store/product-list/product-list.component';
import { ShoppingCartComponent } from 'src/app/components/virtual-store/shopping-cart/shopping-cart.component';
import { ProductDetailComponent } from 'src/app/components/virtual-store/product-detail/product-detail.component';
import { OrderListComponent } from 'src/app/components/virtual-store/order-list/order-list.component';
import { AlertasGuard } from 'src/app/guards/alertas.guard';

const routes: Routes = [
  {
    path: '', component: VirtualStoreContainerComponent,
    children: [
      { path: '', component: ProductListComponent, canActivate: [AlertasGuard] },
      { path: 'carrito', component: ShoppingCartComponent, canActivate: [AlertasGuard] },
      { path: 'mis-pedidos', component: OrderListComponent, canActivate: [AlertasGuard] },
      { path: 'mi-carrito', component: ShoppingCartComponent, canActivate: [AlertasGuard] },
      { path: 'producto', component: ProductDetailComponent, canActivate: [AlertasGuard] }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VirtualStoreRoutingModule { }
